import { ChangeEvent } from "react"
import { Box, Textarea } from "@strapi/design-system"

interface ConfigurationSdkTokenProps {
  data: any
  onChange: (data: any) => void
  onValid: (valid: boolean) => void
}

export const ConfigurationSdkToken = ({
  data,
  onChange,
  onValid: _onValid,
}: ConfigurationSdkTokenProps) => {
  return (
    <Box padding={6} background="neutral0" hasRadius>
      <Textarea
        required
        label="SDK Token"
        name="sdkToken"
        // disabled={!add}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange({
            ...data,
            sdkToken: e.target.value,
          })
        }
        value={data.sdkToken}
      />
    </Box>
  )
}
